<template>
    <div class="professionSpeciality">
        <div class="required_profession cf">
                <div class="female">
                    <div class="profession_list">
                        <span>适合此专业的女生特质</span>
                        <div style="height: 130px;" class="public_scroll_bar">
                            <ul v-show="feMaleCharacter.length>0&&!loadingData" >
                                <li v-for="item in feMaleCharacter" :key="item" class="margin-top float-left margin-right">{{item}}</li>
                            </ul>
                            <div class="margin-top text-default-color" v-show="feMaleCharacter.length<1&&!loadingData">
                                暂无相关特质推荐
                            </div>
                            <loading :show="loadingData"></loading>
                        </div>
                    </div>
                </div>
                <div class="male">
                    <div class="profession_list">
                        <span>适合此专业的男生特质</span>
                        <div style="height: 130px;" class="public_scroll_bar">
                            <ul v-show="maleCharacterList.length>0&&!loadingData">
                                <li v-for="item in maleCharacterList" class="margin-top float-left margin-right">{{item}}</li>
                            </ul>
                            <div class="margin-top text-default-color" v-show="maleCharacterList.length<1&&!loadingData">
                                暂无相关特质推荐
                            </div>
                            <loading :show="loadingData"></loading>
                        </div>
                    </div>
                </div>
        </div>
        <div class="main ">
            <div class="info position-relative" style="min-height:520px;margin-top:160px;">
                <div v-show="tzSm.length>0&&!loadingTzSmContent">
                    <h4  class="tit ">特质说明</h4>
                    <div  class="margin-medium-top">
                        <div v-for="item in tzSm">
                            <div>
                                {{item.name+'('+item.enChar+')'}}
                            </div>
                            <div class="margin-medium-y text-default-color" style="line-height: 30px;">
                                {{item.description}}
                            </div>
                        </div>
                    </div>
                </div>
               <empty v-show="tzSm.length<1&&!loadingTzSmContent" content="暂无特质说明内容"></empty>
                <loading :show="loadingTzSmContent"></loading>
            </div>
        </div>
    </div>
</template>

<script>
    import {EventBus} from "../../../../assets/static/global/event-bus";
    import {professionAnalysis, professionAnalysisDesc} from "../../../../config";

    export default {
        name: "professionSpeciality",
        props:{
            professionId:String
        },
        data(){
            return{
                loadingData:false,
                //获取特质列表
                tzList:[],
                //获取女性相关list
                feMaleCharacter:[],
                //获取男性相关list
                maleCharacterList:[],
                //获取特质说明
                tzSm:[],
                //加载特质说明内容
                loadingTzSmContent:false
            }
        },
        mounted(){
            EventBus.$on('zyTz',(()=>{
                this.searchProfessionTz();
            }))
        },
        methods:{
            async searchProfessionTz(){
                this.loadingData=true;
                let result=await professionAnalysis(this.professionId);
                //查出专业特质
                if(result.status){
                    this.loadingData=false;
                    console.log('我是根据id查出的专业特质');
                    this.tzList=result.data;
                    this.feMaleCharacter=result.data.femaleCharacter;
                    this.maleCharacterList=result.data.maleCharacter;
                    console.log(result.data);
                    this.searchTzSm();
                }else{
                    this.loadingData=false;
                }
            },
            //查出特质说明
            async searchTzSm(){
                this.loadingTzSmContent=true;
                let result=await professionAnalysisDesc();
                if(result.status){
                    this.loadingTzSmContent=false;
                    console.log('特质说明');
                    this.tzSm=result.data;
                    console.log(result.data);
                }else{
                    this.loadingTzSmContent=false;
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
    .professionSpeciality{
        .required_profession{
            padding: 80px 40px 80px 90px;
            >div{
                width: 382px;
                height: 166px;
                position: relative;
                padding: 11px 17px 6px 82px;
                -webkit-box-sizing: border-box;
                box-sizing: border-box;
            }
            >div:before{
                z-index: 1;
                content: "";
                width: 122px;
                height: 122px;
                background-repeat: no-repeat;
                position: absolute;
                top: 23px;
                left: -61px;
            }
            .female:before {
                background-image: url(https://s.diyigaokao.com/v4/sprite/201704271425_01.png);
            }
            .female{
                float: left;
                border: 1px solid #f9c9ca;
                background-color: #fff4f3;
            }
            .male{
                float: right;
                border: 1px solid #bcdcf6;
                background-color: #ecf6fe;
            }
            .male:before {
                background-image: url(https://s.diyigaokao.com/v4/sprite/201704271425_02.png);
            }
        }
    }
</style>
